import DefaultMapper from 'cw-core-admin-ui/src/dataProvider/DefaultMapper';
import { API_BASE_PATH_DEMOWALLET_ADMIN } from '../../constants';

class PurchaseMapper extends DefaultMapper {
	mapResource({ resource }) {
		return 'wallet/tx/purchases';
	}

	prepareGetOne({ type, resource, params, options, mappedResource }) {
		options.url = `${API_BASE_PATH_DEMOWALLET_ADMIN}/${mappedResource}/${params.id}`;
	}
}

export default PurchaseMapper;
